export enum TModerationUser {
  AllowedUsers = 'allowed_users',
  BlockedUsers = 'blocked_users',
  AllowedIps = 'allowed_ips',
  BlockedIps = 'blocked_ips',
  TeamMembers = 'team_members'
}

export interface IUserList {
  isLoading: boolean;
  count: number;
  offset: number;
  users: string[] | { ip: string }[];
  isFetched?: boolean;
}

export { User, UserRole } from '../../comments-and-posts/state/types';
